import { Link } from "@remix-run/react"
import { PodpodLogo } from "~/packages/podpod-logo"

export default function Index() {
  return (
    <div className="w-full h-dvh flex flex-col items-center justify-center text-center">
      <div className="flex flex-col gap-4">
        <PodpodLogo className="mx-auto" />

        <div className="flex flex-col gap-y-1">
          <h2 className="text-sm">This page doesn&apos;t exist</h2>
          <Link to="/app" className="text-xs text-gray-9">
            Back to the app
          </Link>
        </div>
      </div>

      <footer className="fixed bottom-0 left-0 w-full py-4">
        <p className="text-xs text-gray-9">
          A project by{" "}
          <a
            target="_blank"
            rel="noreferrer"
            className="underline text-gray-11 hover:text-gray-12"
            href="https://bonhomme.lol"
          >
            Bonhomme
          </a>{" "}
          and{" "}
          <a
            target="_blank"
            rel="noreferrer"
            className="underline text-gray-11 hover:text-gray-12"
            href="https://simon.am/"
          >
            Simon
          </a>
        </p>
      </footer>
    </div>
  )
}
